
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discovery-phase-services",
      function () {
        return require("private-next-pages/discovery-phase-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discovery-phase-services"])
      });
    }
  